import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function Sparkles2(props: SvgIconProps) {
  const { color, ...rest } = props;
  return (
    <SvgIcon
      {...rest}
      viewBox='0 0 16 16'
    >
      <path
        d='M6.35917 10.5499C6.30262 10.3308 6.18838 10.1308 6.02833 9.9707C5.86828 9.81065 5.66826 9.69641 5.44909 9.63987L1.56369 8.63796C1.4974 8.61914 1.43906 8.57922 1.39752 8.52424C1.35597 8.46927 1.3335 8.40224 1.3335 8.33333C1.3335 8.26443 1.35597 8.1974 1.39752 8.14242C1.43906 8.08745 1.4974 8.04752 1.56369 8.02871L5.44909 7.02617C5.66818 6.96968 5.86815 6.85553 6.0282 6.6956C6.18824 6.53566 6.30253 6.33578 6.35917 6.11672L7.36107 2.23132C7.3797 2.16477 7.41958 2.10614 7.47464 2.06437C7.5297 2.02261 7.59691 2 7.66601 2C7.73512 2 7.80233 2.02261 7.85739 2.06437C7.91245 2.10614 7.95233 2.16477 7.97096 2.23132L8.97223 6.11672C9.02877 6.33589 9.14301 6.53591 9.30306 6.69597C9.46312 6.85602 9.66313 6.97026 9.88231 7.0268L13.7677 8.02807C13.8345 8.0465 13.8934 8.08634 13.9354 8.14149C13.9774 8.19663 14.0002 8.26402 14.0002 8.33333C14.0002 8.40264 13.9774 8.47004 13.9354 8.52518C13.8934 8.58032 13.8345 8.62016 13.7677 8.63859L9.88231 9.63987C9.66313 9.69641 9.46312 9.81065 9.30306 9.9707C9.14301 10.1308 9.02877 10.3308 8.97223 10.5499L7.97032 14.4353C7.9517 14.5019 7.91182 14.5605 7.85676 14.6023C7.8017 14.6441 7.73449 14.6667 7.66538 14.6667C7.59627 14.6667 7.52906 14.6441 7.47401 14.6023C7.41895 14.5605 7.37906 14.5019 7.36044 14.4353L6.35917 10.5499Z'
        stroke={color}
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.3335 2V4.66667'
        stroke={color}
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.6667 3.33301H12'
        stroke={color}
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.66699 11.333V12.6663'
        stroke={color}
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.33333 12H2'
        stroke={color}
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </SvgIcon>
  );
}
